/**
 * Os prazos do `AuthContext` na renovação da sessão. Ficam fora do contexto de propósito: um arquivo de componente que exporta
 * constante quebra o fast refresh (`react-refresh/only-export-components`), e os testes precisam importar os mesmos números.
 */

/**
 * Quanto antes de o access vencer o `AuthContext` renova. Com folga, para a renovação ter tempo de tentar de novo (ver
 * `ESPERA_DEPOIS_DE_FALHA_MS`) antes de as requisições começarem a levar 401.
 */
export const ANTECEDENCIA_DA_RENOVACAO_MS = 5 * 60_000;

/**
 * Espera para tentar de novo quando a renovação devolveu `"tentar_depois"` (manutenção, rede caída, pedido que passou do prazo).
 * Precisa ficar SEMPRE abaixo da janela de retentativa do backend (`JANELA_DE_RETENTATIVA_S = 120`): se o servidor girou o refresh e a
 * resposta se perdeu, só a nova tentativa dentro dessa janela, ainda com o refresh velho, renova sem derrubar a pessoa.
 */
export const ESPERA_DEPOIS_DE_FALHA_MS = 30_000;
